<template>
  <div class="main-content" v-bind:style="warpStyle">
    <div class="login-form">
      <el-form
        ref="loginForm"
        :model="listQuery"
        :rules="loginRules"
        autocomplete="on"
        label-position="left"
        style="width: 100%"
      >
        <div class="login-form-header">
          <div class="form-header-title">Hello!</div>
          <div class="form-header-subtitle">欢迎来到上犹万年青！</div>
        </div>

        <el-form-item prop="username">
          <el-input
            placeholder="请输入用户名"
            v-model="listQuery.username"
            clearable
          />
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            placeholder="请输入登录密码"
            v-model="listQuery.password"
            show-password
          />
        </el-form-item>

        <el-button
          class="login-btn"
          type="primary"
          @click.native.prevent="handleLogin"
        >
          登录
        </el-button>
      </el-form>
    </div>
    <!-- <img class="bg-icon" :src="bgIcon" /> -->
    <van-overlay :show="loading" @click="loading = false">
      <div class="wrapper" @click.stop>
        <van-loading type="spinner" color="#1989fa" />
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { showPhoneAlarm, isWeiXin } from "@/global/function.js";
import { login as userLogin, getSelf, wxLogin } from "@/api/user";
import checkPermission from "@/utils/permission";

export default {
  name: "Login",
  components: {},
  data() {
    const loginBg = require("@/assets/loginbg.png");
    return {
      loading: false,
      height: window.innerHeight + "px",
      listQuery: {
        username: "",
        password: "",
        token: "",
      },
      loginRules: {
        username: [
          {
            required: true,
            message: "用户名不能为空",
            trigger: "blur",
          },
          {
            min: 2,
            max: 20,
            message: "长度在 5 到 20 个字符",
          },
          {
            pattern: /^[A-Za-z0-9]+$/,
            message: "用户名只能为英文及数字",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
          {
            min: 6,
            max: 25,
            message: "长度在 6 到 25个字符",
          },
          // {
          //   pattern: /^(\w){6,25}$/,
          //   message: "只能输入6-25个字母、数字、下划线",
          // },
        ],
      },
      redirect: undefined,
      bgIcon: require("@/assets/login-bg-icon.svg"),
      warpStyle: {
        height: window.innerHeight + "px",
        backgroundImage: `url('${loginBg}')`,
        backgroundSize: "100%",
        backgroundPosition: "bottom",
      },
    };
  },
  watch: {
    $route: {
      handler(route) {
        this.redirect = (route.query && route.query.redirect) || "/";
      },
      immediate: true,
    },
  },
  async created() {
    const href = window.location.href;
    if (href.indexOf("code=") >= 0) {
      const search = location.search;
      const query = Object.assign(
        {},
        ...search
          .replace("?", "")
          .split("&")
          .map((param) => {
            const value = param.split("=");
            return { [value[0]]: value[1] };
          })
      );
      const { data } = await wxLogin({ code: query.code });
      const path = decodeURIComponent(
        location.hash.replace("#/login", "").replace("?redirect=", "")
      );
      if (+data.code === 200) {
        const { data: selfData } = await getSelf();
        let personType = selfData.data.personType;
        this.$store.dispatch("user/loginSuccess", selfData).then((response) => {
          if (personType === 0 || personType === 3) {
            let path = "/dashboard/order";
            if (this.redirect.indexOf("material-check") !== -1) {
              path = this.redirect;
            }
            const newAddr = `${location.origin}${location.pathname}#${path}`;
            location.replace(newAddr);
          } else {
            const newAddr = `${location.origin}${location.pathname}#${
              path && path !== "/" ? path : "/dashboard"
            }`;
            location.replace(newAddr);
          }
        });
      } else if (+data.code === 40000) {
        this.$message({
          type: "info",
          message: data.message,
        });
        this.listQuery.token = data.token;
      }
    } else {
      if (isWeiXin()) {
        let hash = encodeURIComponent(location.hash.replace("#", ""));
        location.href = [
          "https://open.weixin.qq.com/connect/oauth2/authorize?",
          "appid=wx3ceb0ecc06783683",
          "&response_type=code",
          "&scope=snsapi_userinfo",
          "&redirect_uri=" +
            encodeURIComponent(
              location.origin + location.pathname + location.hash
            ),
          "&state=" + hash + "#wechat_redirect",
        ].join("");
      }
    }
  },
  beforeCreate() {
    const flag = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    if (flag === null) {
      const url = window.location.href;
      const baseUrl = url.substr(0, url.indexOf("/sywnq"));
      const pcUrl = baseUrl + "/sywnq-c";
      window.location.href = pcUrl;
    }
  },
  methods: {
    checkPermission,
    handleLogin() {
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          let data = new FormData();
          data.append("username", this.listQuery.username);
          data.append("password", this.listQuery.password);
          data.append("token", this.listQuery.token);

          let response;
          if (this.listQuery.token) {
            response = await wxLogin(data).catch((e) => console.error(e));
          } else {
            response = await userLogin(data).catch((e) => console.error(e));
          }
          const { data: loginResult } = response;
          if (
            showPhoneAlarm(
              true,
              "toast",
              null,
              2000,
              loginResult.code,
              "用户登录",
              loginResult.message
            )
          ) {
            const { data: selfData } = await getSelf();
            const path = decodeURIComponent(
              location.hash.replace("#/login", "").replace("?redirect=", "")
            );
            if (selfData.data.permission.length === 0) {
              showPhoneAlarm(
                true,
                "toast",
                null,
                2000,
                500,
                "",
                "权限不能为空"
              );
              return;
            }
            let personType = selfData.data.personType;
            this.$store
              .dispatch("user/loginSuccess", selfData)
              .then((response) => {
                if (personType === 0 || personType === 3) {
                  let path = "/dashboard/order";
                  if (this.redirect.indexOf("material-check") !== -1) {
                    path = this.redirect;
                  }
                  const newAddr = `${location.origin}${location.pathname}#${path}`;
                  location.replace(newAddr);
                } else {
                  const newAddr = `${location.origin}${location.pathname}#${
                    path && path !== "/" ? path : "/dashboard"
                  }`;
                  location.replace(newAddr);
                }
              });
          }
          if (typeof loginResult.data === "undefined") {
            return;
          }
        } else {
          showPhoneAlarm(
            true,
            "toast",
            "success",
            2000,
            200,
            "用户登录",
            "用户名或密码错误"
          );
          return false;
        }
      });
    },
  },
};
</script>


<style scoped lang="scss">
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
.main-content {
  font-size: 0.4rem;
  background-color: #183b79;
  overflow-x: hidden;
  overflow-y: hidden;

  .bg-icon {
    position: fixed;
    width: 100%;
    bottom: 0;
    padding: 10px;
  }

  .login-form {
    padding: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;

    .login-form-header {
      color: #ffffff;
      margin-bottom: 30px;
      .form-header-title {
        font-size: 30px;
        margin-bottom: 6px;
      }
      .form-header-subtitle {
        font-size: 18px;
      }
    }

    .login-btn {
      width: 100%;
      margin-top: 30px;
      font-size: 18px;
      background-color: #f2bf41;
      color: #ffffff;
      border: 1px solid #f2bf41;
    }
  }
}
</style>
